import { translateOperationalModule } from "@i18n";

import type { ModuleItem } from "../api/licenses/licenses.types";

export const mapReleasedModulesToSelectOptions = (
  modules: ModuleItem[] | undefined,
  translate: (key: string) => string,
) =>
  modules
    ?.filter((moduleItem) => moduleItem.isReleased)
    .map((moduleItem) => ({
      label: translateOperationalModule(moduleItem.module, translate),
      value: moduleItem.id,
    })) ?? [];
